// extracted by mini-css-extract-plugin
export default {"base":"ChevronCaret_base__VXDMS","top":"ChevronCaret_top__RJ2yy","right":"ChevronCaret_right__DB09r","down":"ChevronCaret_down__UFTY+","left":"ChevronCaret_left__EtbUv"};